import { comment } from '@axo/shared/data-access/types';
import { send } from '../../lib/send';
import { IAPI } from '../../lib/models/api';

/**
 * Customer-authed write path for `POST /comment/by/user` (MV-3026).
 *
 * ⚠️ This is a separate endpoint/entity from the agent-only `createComment`
 * (`POST /comment`), which authorizes by reading the request's `OwnerID`
 * and checking that user's agent Role. Customers authenticate via JWT and
 * lack that role, so this call must NOT reuse or modify the agent path —
 * it is modeled on its shape only.
 */
export function postUserComment({ url: { service: baseURL }, token }: IAPI) {
  // Resolves `void`: the endpoint returns `204 No Content` on success (no
  // body). `send` throws on any real error status, so a resolved call means
  // the write succeeded.
  return (userComment: comment.CreateUserComment): Promise<void> =>
    send({
      baseURL,
      token,
      path: `/comment/by/user`,
      method: 'POST',
      body: userComment,
    });
}

/**
 * Customer-authed read path for `GET /comment/by/user` (MV-2935).
 * Returns all user comments for a loan application. Query param is
 * `loanApplicationID` (camelCase). Same customer-JWT auth as the write.
 */
export function getUserComments({ url: { service: baseURL }, token }: IAPI) {
  return (loanApplicationID: string): Promise<comment.UserComment[]> =>
    send<never, comment.UserComment[]>({
      baseURL,
      token,
      path: `/comment/by/user`,
      method: 'GET',
      searchParams: { loanApplicationID },
    });
}
